import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=3f85838f&scoped=true&"
import script from "./NotificationModal.vue?vue&type=script&lang=js&"
export * from "./NotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=3f85838f&prod&lang=scss&scoped=true&"
import style1 from "./NotificationModal.vue?vue&type=style&index=1&id=3f85838f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85838f",
  null
  
)

export default component.exports